import React from 'react';
import * as ds from './dataService';
import { StyledDropDown } from 'modules/components/layer01';
import { appFormUtil } from 'modules/common';


export type SelectInstallationAreaFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: keyof T;
  inputLabel?: string;
  disabled?: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectInstallationAreaFieldProps<T>) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      inputLabel={props.inputLabel ? props.inputLabel : undefined}
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
      disabled={props.disabled}
    />
  );
};
